/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Step5_NameInputs */

const en_dr_step5_name = /** @type {(inputs: Dr_Step5_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 · Choose`)
};

const id_dr_step5_name = /** @type {(inputs: Dr_Step5_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 · Pilih`)
};

/**
* | output |
* | --- |
* | "5 · Choose" |
*
* @param {Dr_Step5_NameInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_step5_name = /** @type {((inputs?: Dr_Step5_NameInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Step5_NameInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_step5_name(inputs)
	return en_dr_step5_name(inputs)
});